import NcsForm from './components/NcsForm';
import NcsLabel from './components/NcsLabel';
import NcsFilter from './components/filters/NcsFilter';
import NcsSelect from './components/filters/NcsSelect';
import NcsMultiSelect from './components/filters/NcsMultiSelect';
import NcsNumberSelectFilter from './components/filters/NcsNumberSelectFilter';
import NcsUnitsElement from './components/elements/NcsUnitsElement';
import NcsUnitsCollocationsElement from './components/elements/NcsUnitsCollocationsElement';
import NcsTokensElement from './components/elements/NcsTokensElement';
import NcsTokensCollocationsElement from './components/elements/NcsTokensCollocationsElement';
import NcsToken from './components/elements/NcsToken';
import NcsTokenUnitField from './components/elements/NcsTokenUnitField';
import NcsElementSection from './components/elements/NcsElementSection';
import NcsGlobalOption from './components/elements/NcsGlobalOption';
import NcsGlobalOptionCheckbox from './components/elements/NcsGlobalOptionCheckbox';
import NcsSearchType from './components/elements/NcsSearchType';
import NcsOrderSelector from './components/NcsOrderSelector';
import NcsPageSizeSelector from './components/pagination/NcsPageSizeSelector';
import NcsPageSelector from './components/pagination/NcsPageSelector';
import NcsPaginationTitle from './components/pagination/NcsPaginationTitle';
import NcsPaginationLinks from './components/pagination/NcsPaginationLinks';
import NcsGoToPage from './components/pagination/NcsGoToPage';
import NcsResetButton from './components/NcsResetButton';
import NcsSearchButton from './components/NcsSearchButton';
import NcsBackButton from './components/NcsBackButton';
import NcsFixedColumnTable from './components/NcsFixedColumnTable';
import NcsTagSelector from './components/tag_selector/NcsTagSelector';
import NcsFriendlySelector from './components/tag_selector/NcsFriendlySelector';
import NcsPatternSelector from './components/tag_selector/NcsPatternSelector';
import NcsResultType from './components/results/NcsResultType';
import NcsResult from './components/results/NcsResult';
import NcsEmptyResult from './components/results/NcsEmptyResult';
import NcsFrequencyResult from './components/results/NcsFrequencyResult';
import NcsFullFrequencyResult from './components/results/full_frequency/NcsFullFrequencyResult';
import NcsFullFrequencyResultTable from './components/results/full_frequency/NcsFullFrequencyResultTable';
import NcsKwicResult from './components/results/kwic/NcsKwicResult';
import NcsKwicResultRow from './components/results/kwic/NcsKwicResultRow';
import NcsKwicResultHeader from './components/results/kwic/NcsKwicResultHeader';
import NcsKwicDownloadButton from './components/results/kwic/NcsKwicDownloadButton';
import NcsMatchingExpressionsFrequencyGroupSelector from './components/results/matching_expressions/NcsMatchingExpressionsFrequencyGroupSelector';
import NcsMatchingExpressionsGroupSelector from './components/results/matching_expressions/NcsMatchingExpressionsGroupSelector';
import NcsMatchingExpressionsResult from './components/results/matching_expressions/NcsMatchingExpressionsResult';
import NcsMatchingExpressionsResultRow from './components/results/matching_expressions/NcsMatchingExpressionsResultRow';
import NcsMatchingExpressionsResultHeader from './components/results/matching_expressions/NcsMatchingExpressionsResultHeader';
import NcsMatchingExpressionsDownloadButton from './components/results/matching_expressions/NcsMatchingExpressionsDownloadButton';
import NcsMatchingExpressionsPageSelector from './components/results/matching_expressions/NcsMatchingExpressionsPageSelector';
import NcsContextResult from './components/results/context/NcsContextResult';
import NcsContextText from './components/results/context/NcsContextText';
import NcsContextDocumentHeader from './components/results/context/NcsContextDocumentHeader';
import NcsContextTextHeader from './components/results/context/NcsContextTextHeader';
import NcsContextTextTitle from './components/results/context/NcsContextTextTitle';
import NcsContextUnitsRow from './components/results/context/NcsContextUnitsRow';
import NcsContextTokensRow from './components/results/context/NcsContextTokensRow';
export default {
  NcsForm: NcsForm,
  NcsLabel: NcsLabel,
  NcsFilter: NcsFilter,
  NcsSelect: NcsSelect,
  NcsMultiSelect: NcsMultiSelect,
  NcsNumberSelectFilter: NcsNumberSelectFilter,
  NcsUnitsElement: NcsUnitsElement,
  NcsUnitsCollocationsElement: NcsUnitsCollocationsElement,
  NcsTokensElement: NcsTokensElement,
  NcsTokensCollocationsElement: NcsTokensCollocationsElement,
  NcsToken: NcsToken,
  NcsTokenUnitField: NcsTokenUnitField,
  NcsElementSection: NcsElementSection,
  NcsGlobalOption: NcsGlobalOption,
  NcsGlobalOptionCheckbox: NcsGlobalOptionCheckbox,
  NcsSearchType: NcsSearchType,
  NcsOrderSelector: NcsOrderSelector,
  NcsPageSizeSelector: NcsPageSizeSelector,
  NcsPageSelector: NcsPageSelector,
  NcsPaginationTitle: NcsPaginationTitle,
  NcsPaginationLinks: NcsPaginationLinks,
  NcsGoToPage: NcsGoToPage,
  NcsResetButton: NcsResetButton,
  NcsSearchButton: NcsSearchButton,
  NcsBackButton: NcsBackButton,
  NcsFixedColumnTable: NcsFixedColumnTable,
  NcsTagSelector: NcsTagSelector,
  NcsFriendlySelector: NcsFriendlySelector,
  NcsPatternSelector: NcsPatternSelector,
  NcsResultType: NcsResultType,
  NcsResult: NcsResult,
  NcsEmptyResult: NcsEmptyResult,
  NcsFrequencyResult: NcsFrequencyResult,
  NcsFullFrequencyResult: NcsFullFrequencyResult,
  NcsFullFrequencyResultTable: NcsFullFrequencyResultTable,
  NcsKwicResult: NcsKwicResult,
  NcsKwicResultRow: NcsKwicResultRow,
  NcsKwicResultHeader: NcsKwicResultHeader,
  NcsKwicDownloadButton: NcsKwicDownloadButton,
  NcsMatchingExpressionsFrequencyGroupSelector: NcsMatchingExpressionsFrequencyGroupSelector,
  NcsMatchingExpressionsGroupSelector: NcsMatchingExpressionsGroupSelector,
  NcsMatchingExpressionsResult: NcsMatchingExpressionsResult,
  NcsMatchingExpressionsResultRow: NcsMatchingExpressionsResultRow,
  NcsMatchingExpressionsResultHeader: NcsMatchingExpressionsResultHeader,
  NcsMatchingExpressionsDownloadButton: NcsMatchingExpressionsDownloadButton,
  NcsMatchingExpressionsPageSelector: NcsMatchingExpressionsPageSelector,
  NcsContextResult: NcsContextResult,
  NcsContextText: NcsContextText,
  NcsContextDocumentHeader: NcsContextDocumentHeader,
  NcsContextTextHeader: NcsContextTextHeader,
  NcsContextTextTitle: NcsContextTextTitle,
  NcsContextUnitsRow: NcsContextUnitsRow,
  NcsContextTokensRow: NcsContextTokensRow
};